import {
  extend,
  configure
} from 'vee-validate';
import {
  required,
  email
} from 'vee-validate/dist/rules';

// import { configure } from 'vee-validate';

configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
    dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
    // ...
  },
  mode: 'lazy',
})


extend('pay', {
  ...required,
  message: '請選擇付款方式'
});
extend('address', {
  ...required,
  message: '請選擇物流'
});
extend('roue', value => {
  return value >= 0;
});
extend('required', {
  ...required,
  message: '內容不能為空'
});

extend('email', {
  ...email,
  message: '請輸入正確的郵箱格式'
});